import { queryOptions, useQuery } from '@tanstack/react-query';
import { generateResponseScheme, type RespondedWith } from '@/models/response';
import { type UserStickersResponse, userStickersResponseSchema } from '@/models/user/custom-sticker';
import { fetcher } from '@/utils/fetcher';

export const userStickersQueryOptions = queryOptions({
  queryKey: ['/GetUserStickers'],
  queryFn: async ({ signal }): Promise<UserStickersResponse> => {
    const response = await fetcher<RespondedWith<UserStickersResponse>>('/GetUserStickers', undefined, {
      validResponseCodes: [0],
      signal,
      schema: generateResponseScheme(userStickersResponseSchema),
    });

    return response.Data ?? { Stickers: [], StickerLimit: 30 };
  },
});

export default function useUserStickers() {
  const query = useQuery(userStickersQueryOptions);

  return {
    ...query,
    stickers: query.data?.Stickers ?? [],
    stickerLimit: query.data?.StickerLimit ?? 30,
    isStickerLimitReached: Boolean(query.data?.StickerLimit && query.data?.Stickers.length >= query.data?.StickerLimit),
  };
}
